import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';
import { WORKFLOW_ADMIN_ROLES } from './nav.js';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

function admin(load: () => Promise<PageModule>, anyOf: string[]): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    const Page = m.default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf} roles={WORKFLOW_ADMIN_ROLES}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
}

export const workflowRoutes: RouteObject[] = [
  { path: '/workflow', lazy: page(() => import('./pages/WorkflowListPage.js')) },
  { path: '/workflow/inbox', lazy: page(() => import('./pages/InboxPage.js')) },
  { path: '/workflow/new', lazy: page(() => import('./pages/RequestFormPage.js')) },
  { path: '/workflow/retention', lazy: page(() => import('./pages/RetentionSearchPage.js')) },
  { path: '/workflow/stamp', lazy: page(() => import('./pages/StampPage.js')) },
  { path: '/workflow/requests/:id', lazy: page(() => import('./pages/RequestDetailPage.js')) },
  { path: '/workflow/requests/:id/edit', lazy: page(() => import('./pages/RequestFormPage.js')) },
  { path: '/workflow/requests/:id/print', lazy: page(() => import('./pages/RequestPrintPage.js')) },
  { path: '/workflow/delegations', lazy: page(() => import('./pages/DelegationsPage.js')) },
  { path: '/workflow/templates', lazy: admin(() => import('./pages/TemplatesPage.js'), ['workflow.template.manage']) },
  { path: '/workflow/templates/new', lazy: admin(() => import('./pages/TemplateEditorPage.js'), ['workflow.template.manage']) },
  { path: '/workflow/templates/:code', lazy: admin(() => import('./pages/TemplateEditorPage.js'), ['workflow.template.manage']) },
  { path: '/workflow/routes', lazy: admin(() => import('./pages/RoutesPage.js'), ['workflow.route.manage']) },
  { path: '/workflow/routes/new', lazy: admin(() => import('./pages/RouteEditorPage.js'), ['workflow.route.manage']) },
  { path: '/workflow/routes/:id', lazy: admin(() => import('./pages/RouteEditorPage.js'), ['workflow.route.manage']) },
];
